import apiClient from './apiClient'
import { 
  TemplateListResponse, 
  TemplateResponse, 
  CreateTemplateRequest, 
  UpdateTemplateRequest,
  ApiResponse,
  ValidationType,
  ValidationResponse,
  WebhookTestRequest,
  WebhookTestResponse
} from '../types/template.types'

export const templateService = {
  // Listar templates
  async getTemplates(page: number = 1, limit: number = 20): Promise<TemplateListResponse> {
    const response = await apiClient.get(`/templates?page=${page}&limit=${limit}`)
    return response.data
  },

  // Buscar template por ID
  async getTemplate(id: number): Promise<TemplateResponse> {
    const response = await apiClient.get(`/templates/${id}`)
    return response.data
  },

  // Criar template
  async createTemplate(template: CreateTemplateRequest): Promise<TemplateResponse> {
    const response = await apiClient.post('/templates', template)
    return response.data
  },

  // Atualizar template
  async updateTemplate(template: UpdateTemplateRequest): Promise<TemplateResponse> {
    const { id, ...data } = template
    const response = await apiClient.put(`/templates/${id}`, data)
    return response.data
  },

  // Deletar template
  async deleteTemplate(id: number): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.delete(`/templates/${id}`)
    return response.data
  },

  // Testar template com API
  async testTemplate(id: number, testData: any): Promise<ApiResponse> {
    const response = await apiClient.post(`/templates/${id}/test`, testData)
    return response.data
  },

  // Detectar variáveis no template
  async detectVariables(template: string): Promise<string[]> {
    const response = await apiClient.post('/templates/detect-variables', { template })
    return response.data.variables
  },

  // Validar template
  async validateTemplate(template: string): Promise<{ valid: boolean; errors: string[] }> {
    const response = await apiClient.post('/templates/validate', { template })
    return response.data
  },

  // Validar entrada do usuário
  async validateInput(input: string, validationType: string, templateId?: number): Promise<ValidationResponse> {
    const response = await apiClient.post('/templates/validate-input', { 
      input, 
      validation_type: validationType,
      template_id: templateId 
    })
    return response.data
  },

  // Testar webhook
  async testWebhook(webhookData: WebhookTestRequest): Promise<WebhookTestResponse> {
    const response = await apiClient.post('/templates/test-webhook', webhookData)
    return response.data
  },

  // Listar tipos de validação
  async getValidationTypes(): Promise<{ success: boolean; data: ValidationType[] }> {
    const response = await apiClient.get('/templates/types/validation')
    return response.data
  }
}
